import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAnalyticsHub = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.71429 1V0C8.162 0 7.71429 0.447715 7.71429 1L8.71429 1ZM19 11.2857V12.2857C19.5523 12.2857 20 11.838 20 11.2857H19ZM8.71429 11.2857H7.71429V12.2857H8.71429V11.2857ZM8.71429 19V20C13.5271 20 17.4286 16.0985 17.4286 11.2857H16.4286H15.4286C15.4286 14.9939 12.4225 18 8.71429 18V19ZM1 11.2857H0C0 16.0985 3.90152 20 8.71429 20V19V18C5.00609 18 2 14.9939 2 11.2857H1ZM1 11.2857H2C2 7.57752 5.00609 4.57143 8.71429 4.57143V3.57143V2.57143C3.90152 2.57143 0 6.47295 0 11.2857H1ZM8.71429 1V2C13.8426 2 18 6.15736 18 11.2857H19H20C20 5.05279 14.9472 0 8.71429 0V1ZM8.71429 1H7.71429V11.2857H8.71429H9.71429V1H8.71429ZM8.71429 11.2857V12.2857H19V11.2857V10.2857H8.71429V11.2857Z",
		fill: "#C1CDDA"
	})
});
export default SvgAnalyticsHub;
